
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { BoxStatusType } from '@/types';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationDocs extends Mixins(OperationComponentMixin) {
  get taskRVersion(): number | null {
    return this.operationChild?.taskVersions.R ?? 1;
  }

  chipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey lighten-2';

      case 'done':
        return 'statusDone';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  chipOutlined(value: BoxStatusType | null): boolean {
    switch (value) {
      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  tooltipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  tooltipText(prefix: string, value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return `${prefix} (assente)`;

      case 'na':
        return `${prefix} (non applicabile)`;

      case 'waiting':
        return `${prefix} (in attesa di terzi)`;

      default:
        break;
    }
    return prefix;
  }

  get dataDicoTooltipText(): string {
    if (this.operationChild?.type === 'elettrica-figlia') return 'Data DICO (Elettrica)';
    return 'Data DICO (Termica)';
  }

  get dChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docD) : '';
  }
  get vChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docV) : '';
  }

  get dChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docD) : false;
  }
  get vChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docV) : false;
  }

  get dTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docD) : '';
  }
  get vTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docV) : '';
  }

  get dTooltipText(): string {
    const base = this.taskRVersion === 1 ? 'DICO' : 'DICO e Visura camerale';

    return this.operationChild
      ? this.tooltipText(base, this.operationChild?.docD)
      : base;
  }
  get vTooltipText(): string {
    return this.operationChild ? this.tooltipText('Visura camerale', this.operationChild?.docV) : 'Visura camerale';
  }

  get docDHasNotes(): boolean {
    return this.operationChild?.docDHasNotes === true;
  }
  get docVHasNotes(): boolean {
    return this.operationChild?.docVHasNotes === true;
  }

  get dicoDate(): Date | null {
    return this.operationChild?.docDDate ? this.operationChild?.docDDate : null;
  }

  get firstColumnClass(): string {
    if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('R=e')) return 'error';
    return '';
  }

  onEdit() {
    console.log('OperationDocs: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
